module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av393-10b94ba48f4bb878065a40d4aca81874.jpg";